import { render } from "./PositionsTable.vue?vue&type=template&id=dca63ee2"
import script from "./PositionsTable.vue?vue&type=script&lang=js"
export * from "./PositionsTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__